import { render, staticRenderFns } from "./ComprometimentoAprovadores.vue?vue&type=template&id=5cf33326"
import script from "./ComprometimentoAprovadores.vue?vue&type=script&lang=js"
export * from "./ComprometimentoAprovadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports